import { createSlice } from '@reduxjs/toolkit';

import { estelamSabtAhvalThunk } from 'Feature/Common/Common/Actions/Thunks/estelamSabtAhvalThunk';
import { getActiveModdatHayeBimehNameh } from 'Feature/Common/Common/Actions/Thunks/getActiveModdatHayeBimehNameh';
import { getAddressWithPostCodeThunk } from 'Feature/Common/Common/Actions/Thunks/getAddressWithPostCodeThunk';
import { HaghighiHoghooghiEnum } from 'Feature/Common/Common/Types/Enums/HaghighiHoghooghiEnum';
import { JensiatEnum } from 'Feature/Common/Common/Types/Enums/JensiatEnum';
import { getAllTarhHayeSodoorByNoeBimeh } from 'Feature/Khodro/ShakhsSales/Thunks/getAllTarhHayeSodoorByNoeBimeh';
import Consts from 'Framework/Consts';
import LabelValueType from 'Shared/Core/Common/Models/LabelValueType';
import {
  convertToEnglishDigits,
  gregorianDateTime,
  keepOnlyDigits,
} from 'Shared/Utils/Extensions/String/StringExtensions';

import StepOneModelInitialState from '../Components/01-StepOne/Models/StepOneModelInitialState';
import StepTwoModelInitialState from '../Components/02-StepTwo/Models/StepTwoModelInitialState';
import StepThreeModelInitialState from '../Components/03-StepThree/Models/StepThreeModelInitialState';
import StepFourModelInitialState from '../Components/04-StepFour/Models/StepFourModelInitialState';
import StepFifthModelInitialState from '../Components/05-StepFifth/Models/StepFifthModelInitialState';
import StepSixModelInitialState from '../Components/06-StepSix/Models/StepSixModelInitialState';
import StepSevenModelInitialState from '../Components/07-StepSeven/Models/StepSevenModelInitialState';

import {
  GetAllAnvaeSherkatBimeh,
  addToOrder,
  addToOrderAtashsoozi,
  createShenasehPardakhtAtashsoozi,
  estelamAtashsooziOmumi,
  getActiveAnvaeFaaliatByNoeBimehNameh,
  getActiveAnvaeSazeh,
  getActiveGoroohHayeMoredBimeh,
  getActivePoosheshHayeEzafi,
  getBimehNamehAtashsooziConfig,
  getDescriptionsByNoeBimehNameh,
  getPoosheshEzafiShowInSodoor,
} from './action';
import { IAtashsooziEstelamAndSodoorState, IMavaredTafkiki } from './model';

function replaceDots(template: string, values: string[]) {
  let result = template;
  for (const element of values) {
    result = result.replace(/\.\.+/, element);
  }
  return result;
}

const initialState: IAtashsooziEstelamAndSodoorState = {
  stepOneData: StepOneModelInitialState,
  stepTwoData: StepTwoModelInitialState,
  stepThreeData: StepThreeModelInitialState,
  stepFourData: StepFourModelInitialState,
  stepFiveData: StepFifthModelInitialState,
  stepSixData: StepSixModelInitialState,
  stepSevenData: StepSevenModelInitialState,

  estelam: {
    bimehNameh: {},
    moredHayebimeh: [],
  },

  estelamResult: {
    loading: false,
    isSuccess: false,
    data: {
      avarez: null,
      haghBimehKhales: null,
      haghBimehPardakhti: null,
      maaliat: null,
      tarikhPayan: null,
      vahedPooli: null,
      totalDiscount: null,
      discountDetails: null,
      haghBimehDetails: null,
      wepodDiscountUsed: null,
    },
  },

  getCodeShenasehPardakht: {
    address: {},
    moddatBimehNamehId: 0,
    tarafHayeGharardad: [],
    mavaredTafkiki: [],
    poosheshHayeKoli: [],
  },

  getCodeShenasehPardakhtResult: {
    isSuccess: false,
    loading: false,
    data: {},
  },

  tarhTakhfif: {
    loading: false,
    data: [],
  },

  wizard: {
    begin: 1,
    end: 7,
    current: 1,
  },

  anvaeSherkatBimeh: {
    loading: false,
    data: [],
  },

  addToOrderResponse: {
    loading: false,
  },

  anvaeFaaliat: {
    loading: false,
    data: [],
  },

  anvaeSazeh: {
    loading: false,
    data: [],
  },

  moddatHayeBimehNameh: {
    loading: false,
    data: [],
  },

  khataratEzafi: {
    loading: false,
    data: [],
  },
  estelamSabtAhval: {
    loading: false,
  },

  goroohHayeMoredBimeh: {
    loading: false,
    data: [],
  },

  bimehNamehConfig: {
    loading: false,
    data: {
      senSakhtemanMinValue: 1,
      senSakhtemanMaxValue: 20,
    },
  },

  moredBImehDescription: {
    loading: false,
    data: [],
  },

  codeposti: {
    loading: false,
  },

  poosheshEzafiShowInSodoor: {
    loading: false,
    data: [],
  },

  selectedPoosheshHayeKoli: [],
};

export const atashsooziEstelamAndSodoorReducer = createSlice({
  name: 'Atashsoozi/EstelamAndSodoor',
  initialState: initialState,
  reducers: {
    setEstelamAndSodoorBimehNamehInitialState: (state) => {
      state.stepOneData = initialState.stepOneData;
      state.stepTwoData = initialState.stepTwoData;
      state.stepThreeData = initialState.stepThreeData;
      state.stepFourData = initialState.stepFourData;
      state.stepFiveData = initialState.stepFiveData;
      state.stepSixData = initialState.stepSixData;
      state.stepSevenData = initialState.stepSevenData;
      state.tarhTakhfif = initialState.tarhTakhfif;
      state.addToOrderResponse = initialState.addToOrderResponse;
      state.wizard = initialState.wizard;
      state.selectedPoosheshHayeKoli = initialState.selectedPoosheshHayeKoli;
    },
    setStepOneModel: (state, action) => {
      state.stepOneData = action.payload;
      state.stepFiveData.city = action.payload.cityMoredBimehCoreId;
      state.stepFiveData.province = action.payload.provinceMoredBimehCoreId;
    },
    clearStepOneModel: (state) => {
      state.stepOneData = StepOneModelInitialState;
    },
    setStepOneCommand: (state) => {
      state.estelam.bimehNameh.noeFaaliatCoreId = state.stepOneData.noeFaaliatCoreId;
      state.estelam.bimehNameh.noeSazehCoreId = state.stepOneData.noeSazehCoreId;
      state.estelam.bimehNameh.cityMoredBimehCoreId = state.stepOneData.cityMoredBimehCoreId;
      state.estelam.bimehNameh.senSakhteman = state.stepOneData.senSakhteman ?? 0;

      state.getCodeShenasehPardakht.noeFaaliatCoreId = Array.isArray(state.stepOneData.noeFaaliatCoreId)
        ? state.stepOneData.noeFaaliatCoreId[0]
        : state.stepOneData.noeFaaliatCoreId;
      state.getCodeShenasehPardakht.noeSazehCoreId = Array.isArray(state.stepOneData.noeSazehCoreId)
        ? state.stepOneData.noeSazehCoreId[0]
        : state.stepOneData.noeSazehCoreId;
      state.getCodeShenasehPardakht.moredBimehCityCoreId = state.stepOneData.cityMoredBimehCoreId;
      state.getCodeShenasehPardakht.senSakhteman = state.stepOneData.senSakhteman ?? 0;
    },
    setStepTwoModel: (state, action) => {
      state.stepTwoData = action.payload;
    },
    setStepTwoCommand: (state, action) => {
      state.estelam.moredHayebimeh = action.payload.moredHayebimeh;
      //state.stepFourData = StepFourModelInitialState
    },
    clearStepTwoModel: (state) => {
      state.stepTwoData = StepTwoModelInitialState;
    },
    setStepThreeModel: (state, action) => {
      state.stepThreeData = action.payload;
    },
    setStepThreeCommand: (state) => {
      state.getCodeShenasehPardakht.sherkatBimehGhablCoreId = Array.isArray(state.stepThreeData.sherkatBimehGhabl)
        ? state.stepThreeData.sherkatBimehGhabl[0]
        : state.stepThreeData.sherkatBimehGhabl;
      state.getCodeShenasehPardakht.shomarehBimehnamehGhabl = state.stepThreeData.shomarehBimehGhabl ?? undefined;
      state.getCodeShenasehPardakht.tarikhEnghezaBimehnamehGhabl =
        gregorianDateTime(state.stepThreeData.tarikhEnghezaBimehGhabl) ?? undefined;
    },
    clearStepThreeModel: (state) => {
      state.stepThreeData = StepThreeModelInitialState;
    },
    setStepFourModel: (state, action) => {
      state.stepFourData = action.payload;
    },
    clearStepFourModel: (state) => {
      state.stepFourData = StepFourModelInitialState;
    },
    setStepFourCommand: (state, action) => {
      state.estelam.bimehNameh.tarikhShoroo = gregorianDateTime(state.stepFourData.tarikhShoroBimehNameh) ?? new Date();
      state.selectedPoosheshHayeKoli = action.payload.pooshHayeKoli;
      const poosheshHayeKoli = state.stepFourData.khataratBimehNameh?.map((c: any) => ({
        coreId: c,
        sarmayeh: state.selectedPoosheshHayeKoli?.find((p) => p.coreId === c)?.sarmayeh ?? 0,
      }));
      state.estelam.poosheshHayeKoli = poosheshHayeKoli;
      //state.estelam.tarhHayeSodoorCoreId = state.stepFourData.tarhSodoor;
      state.estelam.bimehNameh.moddatBimehNamehId = state.stepFourData.moddatBimehNamehId;
      if (state.stepFourData.wepodDiscountCode && action.payload?.inquiryDiscountCodeResult?.isSuccess === true) {
        state.estelam.discountCode = state.stepFourData.wepodDiscountCode;
        state.estelam.wepodUserId = state.stepFourData.wepodUserId ?? undefined;
      } else {
        state.estelam.discountCode = undefined;
        state.estelam.wepodUserId = undefined;
      }

      state.getCodeShenasehPardakht.tarikhShoroo =
        gregorianDateTime(state.stepFourData.tarikhShoroBimehNameh) ?? new Date();
      state.getCodeShenasehPardakht.moddatBimehNamehId = state.stepFourData.moddatBimehNamehId;
      state.getCodeShenasehPardakht.poosheshHayeKoli = poosheshHayeKoli;
      //state.getCodeShenasehPardakht.tarhHa = state.stepFourData.tarhSodoor;
      state.getCodeShenasehPardakht.moredBimeh = 'مورد بیمه';
      if (state.stepFourData.wepodDiscountCode && action.payload?.inquiryDiscountCodeResult?.isSuccess === true) {
        state.getCodeShenasehPardakht.discountCode = state.stepFourData.wepodDiscountCode;
        state.getCodeShenasehPardakht.wepodUserId = state.stepFourData.wepodUserId ?? undefined;
      } else {
        state.getCodeShenasehPardakht.discountCode = undefined;
        state.getCodeShenasehPardakht.wepodUserId = undefined;
      }
    },
    setStepFiveModel: (state, action) => {
      state.stepFiveData = action.payload;
    },
    clearStepFiveModel: (state) => {
      state.stepFiveData = StepFifthModelInitialState;
    },
    setStepFiveCommand: (state) => {
      const stepFiveData = state.stepFiveData;
      state.getCodeShenasehPardakht.addressMoredBimeh = `${stepFiveData.khiabanAsli} ${stepFiveData.kocheh} پلاک ${stepFiveData.pelak} طبقه ${stepFiveData.tabagheh} واحد ${stepFiveData.vahed}`;
      state.getCodeShenasehPardakht.codePostiMoredBimeh = convertToEnglishDigits(
        keepOnlyDigits(stepFiveData.codePosti ?? '')
      );
      state.getCodeShenasehPardakht.shomarehTelefonSabet =
        stepFiveData.tel?.replaceAll(' ', '').replaceAll('(', '').replaceAll(')', '') ?? undefined;
      state.getCodeShenasehPardakht.tedadTabaghatSakhteman = stepFiveData.tedadKolTabaghat ?? undefined;
      state.getCodeShenasehPardakht.tedadVahedSakhteman = stepFiveData.tedadKolVahedHa ?? undefined;
      state.getCodeShenasehPardakht.moredBimehCityCoreId = stepFiveData.city;

      state.getCodeShenasehPardakht.mavaredTafkiki = state.estelam.moredHayebimeh?.map((item) => {
        let description = state.moredBImehDescription.data.find(
          (c: any) => c.goroohMoredBimehCoreId === item.goroohMoredBimehCoreId
        )?.description;

        if (
          state.goroohHayeMoredBimeh.data.find(
            (c: any) =>
              c.coreId === item.goroohMoredBimehCoreId &&
              c.displayTitle === Consts.env.REACT_APP_ATASHSOOZI_SAKHTEMAN_TITLE
          )
        ) {
          const str = description as string;

          const noeFaaliat = state.anvaeFaaliat?.data?.find(
            (c: any) => c.value === state.stepOneData.noeFaaliatCoreId
          )?.label;
          const metrazh = state.stepTwoData.metrazh;
          const tabagheh = stepFiveData.tabagheh;
          const tedadKolTabaghat = stepFiveData.tedadKolTabaghat;
          const tedadKolVahedHa = stepFiveData.tedadKolVahedHa;
          const noeSazeh = state.anvaeSazeh?.data?.find(
            (c: any) => c.value === state.stepOneData.noeSazehCoreId
          )?.label;

          description = replaceDots(str, [noeFaaliat, metrazh, tabagheh, tedadKolTabaghat, tedadKolVahedHa, noeSazeh]);
        }

        return {
          goroohMoredBimehCoreId: item.goroohMoredBimehCoreId,
          poosheshHayeJozei: item.poosheshHayeJozi,
          sarmayeh: item.sarmayeh,
          sharh: description,
        } as IMavaredTafkiki;
      }) as IMavaredTafkiki[];
    },
    setStepSixModel: (state, action) => {
      state.stepSixData = action.payload;
    },
    clearStepSixModel: (state) => {
      state.stepSixData = StepSixModelInitialState;
    },
    setStepSixCommand: (state) => {
      state.getCodeShenasehPardakht.isMalek = state.stepSixData.isMalek;
      state.getCodeShenasehPardakht.isMostajerd = state.stepSixData.isMostajer;

      state.getCodeShenasehPardakht.tarafHayeGharardad = [
        {
          naam: state.stepSixData.naamBimehGozar ?? '',
          naamKhanevadegi: state.stepSixData.namKhanevadegiBimehGozar ?? '',
          codeMelli: state.stepSixData.codeMelliBimehGozar ?? '',
          tarikhTavalod: gregorianDateTime(state.stepSixData.tarikhTavalodBimehGozar) ?? undefined,
          jensiat: state.stepSixData.jensiatiBimehGozar as JensiatEnum,

          melliatCoreId: Consts.env.REACT_APP_MELLIAT_ID,
          haghighiHoghooghi: HaghighiHoghooghiEnum.HAGHIGHI,
          isZinaf: true,
          darsadSahmZinaf: 100,
          isBimehgozar: true,
          isTarafAsli: true,
          isPardakhtKonandeh: true,
        },
      ];
    },
    setStepSevenModel: (state, action) => {
      state.stepSevenData = action.payload;
    },
    clearStepSevenModel: (state) => {
      state.stepSevenData = StepSevenModelInitialState;
    },
    resetWizard: (state) => {
      state.wizard = initialState.wizard;
    },
    setStepSevenCommand: (state) => {
      state.getCodeShenasehPardakht.address.cityCoreId = state.stepSevenData.city;
      state.getCodeShenasehPardakht.address.codePosti = convertToEnglishDigits(
        keepOnlyDigits(state.stepSevenData.codePosti ?? '')
      );
      state.getCodeShenasehPardakht.address.mobile = convertToEnglishDigits(
        state.stepSevenData.mobile?.replace('(', '').replace(')', '').replace('-', '').replace(' ', '') ?? ''
      );
      state.getCodeShenasehPardakht.address.neshani = state.stepSevenData.address ?? undefined;
    },
    estelamAndSodoorWizardNextStep: (state) => {
      let nextStep = 0;
      nextStep = state.wizard.current + 1;
      if (nextStep <= state.wizard.end) {
        state.wizard.current = nextStep;
      }
    },
    estelamAndSodoorWizardPreviousStep: (state) => {
      let previousStep = 0;
      previousStep = state.wizard.current - 1;
      if (previousStep >= state.wizard.begin) {
        state.wizard.current = previousStep;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllAnvaeSherkatBimeh.pending, (state) => {
        state.anvaeSherkatBimeh.loading = true;
      })
      .addCase(GetAllAnvaeSherkatBimeh.fulfilled, (state, action) => {
        state.anvaeSherkatBimeh.loading = false;
        if (action.payload !== undefined) {
          const list: any[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.bimehMarkaziTitle,
          }));
          state.anvaeSherkatBimeh.data = list;
        }
        return state;
      })
      .addCase(GetAllAnvaeSherkatBimeh.rejected, (state) => {
        state.anvaeSherkatBimeh.loading = false;
      });

    builder
      .addCase(addToOrder.pending, (state) => {
        state.addToOrderResponse.loading = true;
      })
      .addCase(addToOrder.fulfilled, (state) => {
        state.addToOrderResponse.loading = false;
      })
      .addCase(addToOrder.rejected, (state) => {
        state.addToOrderResponse.loading = false;
      });

    builder
      .addCase(getAllTarhHayeSodoorByNoeBimeh.pending, (state) => {
        state.tarhTakhfif.loading = true;
      })
      .addCase(getAllTarhHayeSodoorByNoeBimeh.fulfilled, (state, action) => {
        state.tarhTakhfif.loading = false;
        if (action.payload !== undefined) {
          const list: any[] = action.payload?.map((item: any) => ({
            value: item.coreId,
            label: item.displayTitle,
          }));
          state.tarhTakhfif.data = list;
        }
        return state;
      })
      .addCase(getAllTarhHayeSodoorByNoeBimeh.rejected, (state) => {
        state.tarhTakhfif.loading = false;
      });

    builder
      .addCase(getActiveAnvaeFaaliatByNoeBimehNameh.pending, (state) => {
        state.anvaeFaaliat.loading = true;
      })
      .addCase(getActiveAnvaeFaaliatByNoeBimehNameh.fulfilled, (state, action) => {
        state.anvaeFaaliat.loading = false;
        if (action.payload !== undefined) {
          const list: any[] = action.payload?.map((item: any) => ({
            label: item.displayTitle,
            value: item.coreId,
          }));
          state.anvaeFaaliat.data = list;
        }
        return state;
      })
      .addCase(getActiveAnvaeFaaliatByNoeBimehNameh.rejected, (state) => {
        state.anvaeFaaliat.loading = false;
      });

    builder
      .addCase(getActiveAnvaeSazeh.pending, (state) => {
        state.anvaeSazeh.loading = true;
      })
      .addCase(getActiveAnvaeSazeh.fulfilled, (state, action) => {
        state.anvaeSazeh.loading = false;
        if (action.payload !== undefined) {
          const list: any[] = action.payload?.map((item: any) => ({
            label: item.displayTitle,
            value: item.coreId,
          }));
          state.anvaeSazeh.data = list;
        }
        return state;
      })
      .addCase(getActiveAnvaeSazeh.rejected, (state) => {
        state.anvaeSazeh.loading = false;
      });

    builder
      .addCase(getActivePoosheshHayeEzafi.pending, (state) => {
        state.khataratEzafi.loading = true;
      })
      .addCase(getActivePoosheshHayeEzafi.fulfilled, (state, action) => {
        state.khataratEzafi.loading = false;
        if (action.payload !== undefined) {
          const list: any[] = action.payload?.map((item: any) => ({
            label: item.displayTitle,
            value: item.coreId,
            noePoosheshCode: item.noePoosheshCode,
            noePoosheshTitle: item.noePoosheshTitle,
            anvaeBimeh: item.anvaeBimeh,
            isRequired: item.isPoosheshAsli,
            needToVisit: item.needToVisit,
          }));
          state.khataratEzafi.data = list;
        }
        return state;
      })
      .addCase(getActivePoosheshHayeEzafi.rejected, (state) => {
        state.khataratEzafi.loading = false;
      });

    builder
      .addCase(estelamSabtAhvalThunk.pending, (state) => {
        state.estelamSabtAhval.loading = true;
      })
      .addCase(estelamSabtAhvalThunk.fulfilled, (state) => {
        state.estelamSabtAhval.loading = false;
      })
      .addCase(estelamSabtAhvalThunk.rejected, (state) => {
        state.estelamSabtAhval.loading = false;
      });

    builder
      .addCase(estelamAtashsooziOmumi.pending, (state) => {
        state.estelamResult.loading = true;
      })
      .addCase(estelamAtashsooziOmumi.fulfilled, (state, action) => {
        state.estelamResult.loading = false;
        if (action.payload !== undefined) {
          state.estelamResult.data = {
            haghBimehKhales: action.payload?.haghBimehKhales,
            haghBimehPardakhti: action.payload?.haghBimehPardakhti,
            maaliat: action.payload?.maaliat,
            avarez: action.payload?.avarez,
            vahedPooli: action.payload?.vahedPooli,
            tarikhPayan: action.payload?.tarikhPayan,
            totalDiscount: action.payload?.totalDiscount,
            wepodDiscountUsed: action.payload?.wepodDiscountUsed,
            discountDetails: action.payload?.discountDetails,
            haghBimehDetails: action.payload?.haghBimehDetails,
          };
          state.estelamResult.isSuccess = true;
        } else {
          state.estelamResult.data = undefined;
        }

        return state;
      })
      .addCase(estelamAtashsooziOmumi.rejected, (state) => {
        state.estelamResult.loading = false;
      });

    builder
      .addCase(getActiveGoroohHayeMoredBimeh.pending, (state) => {
        state.goroohHayeMoredBimeh.loading = true;
      })
      .addCase(getActiveGoroohHayeMoredBimeh.fulfilled, (state, action) => {
        state.goroohHayeMoredBimeh.loading = false;
        if (action.payload !== undefined) {
          state.goroohHayeMoredBimeh.data = action.payload;
        }
        return state;
      })
      .addCase(getActiveGoroohHayeMoredBimeh.rejected, (state) => {
        state.goroohHayeMoredBimeh.loading = false;
      });

    builder
      .addCase(getBimehNamehAtashsooziConfig.pending, (state) => {
        state.bimehNamehConfig.loading = true;
      })
      .addCase(getBimehNamehAtashsooziConfig.fulfilled, (state, action) => {
        state.bimehNamehConfig.loading = false;
        if (action.payload !== undefined) {
          state.bimehNamehConfig.data = action.payload;
        }
        return state;
      })
      .addCase(getBimehNamehAtashsooziConfig.rejected, (state) => {
        state.bimehNamehConfig.loading = false;
      });

    builder
      .addCase(getDescriptionsByNoeBimehNameh.pending, (state) => {
        state.moredBImehDescription.loading = true;
      })
      .addCase(getDescriptionsByNoeBimehNameh.fulfilled, (state, action) => {
        state.moredBImehDescription.loading = false;
        if (action.payload !== undefined) {
          state.moredBImehDescription.data = action.payload;
        }
        return state;
      })
      .addCase(getDescriptionsByNoeBimehNameh.rejected, (state) => {
        state.moredBImehDescription.loading = false;
      });

    builder
      .addCase(getActiveModdatHayeBimehNameh.pending, (state) => {
        state.moddatHayeBimehNameh.loading = true;
      })
      .addCase(getActiveModdatHayeBimehNameh.fulfilled, (state, action) => {
        state.moddatHayeBimehNameh.loading = false;
        if (action.payload !== undefined) {
          const list: LabelValueType[] = action.payload?.map((item: any) => ({
            value: item.id,
            label: item.title,
          }));
          state.moddatHayeBimehNameh.data = list;
        }
        return state;
      })
      .addCase(getActiveModdatHayeBimehNameh.rejected, (state) => {
        state.moddatHayeBimehNameh.loading = false;
      });

    builder
      .addCase(createShenasehPardakhtAtashsoozi.pending, (state) => {
        state.getCodeShenasehPardakhtResult.loading = true;
        state.getCodeShenasehPardakhtResult.isSuccess = false;
      })
      .addCase(createShenasehPardakhtAtashsoozi.fulfilled, (state, action) => {
        state.getCodeShenasehPardakhtResult.loading = false;
        if (action.payload !== undefined) {
          state.getCodeShenasehPardakhtResult.data = {
            haghbimehKhales: action.payload?.haghbimehKhales,
            maaliat: action.payload?.maaliat,
            avarez: action.payload?.avarez,
            vahedPooli: action.payload?.vahedPooli,
            mablagh: action.payload?.mablagh,
            id: action.payload?.id,
            codeShenaseh: action.payload?.codeShenaseh,
            shenasehPardakht: action.payload?.shenasehPardakht,
            tarikhPayan: action.payload?.tarikhPayan,
            totalDiscount: action.payload?.totalDiscount,
            wepodDiscountUsed: action.payload?.wepodDiscountUsed,
            discountDetails: action.payload?.discountDetails,
            haghBimehDetails: action.payload?.haghBimehDetails,
          };
          state.getCodeShenasehPardakhtResult.isSuccess = true;
        }
        return state;
      })
      .addCase(createShenasehPardakhtAtashsoozi.rejected, (state) => {
        state.getCodeShenasehPardakhtResult.loading = false;
      });

    builder
      .addCase(addToOrderAtashsoozi.pending, (state) => {
        state.addToOrderResponse.loading = true;
      })
      .addCase(addToOrderAtashsoozi.fulfilled, (state) => {
        state.addToOrderResponse.loading = false;
      })
      .addCase(addToOrderAtashsoozi.rejected, (state) => {
        state.addToOrderResponse.loading = false;
      });

    builder
      .addCase(getAddressWithPostCodeThunk.pending, (state) => {
        state.codeposti.loading = true;
      })
      .addCase(getAddressWithPostCodeThunk.fulfilled, (state) => {
        state.codeposti.loading = false;
      })
      .addCase(getAddressWithPostCodeThunk.rejected, (state) => {
        state.codeposti.loading = false;
      });

    builder
      .addCase(getPoosheshEzafiShowInSodoor.pending, (state) => {
        state.poosheshEzafiShowInSodoor.loading = true;
      })
      .addCase(getPoosheshEzafiShowInSodoor.fulfilled, (state, action) => {
        state.poosheshEzafiShowInSodoor.loading = false;
        state.poosheshEzafiShowInSodoor.data = action.payload;

        return state;
      })
      .addCase(getPoosheshEzafiShowInSodoor.rejected, (state) => {
        state.poosheshEzafiShowInSodoor.loading = false;
      });
  },
});

export const {
  setStepOneModel,
  setStepOneCommand,
  setStepTwoModel,
  setStepTwoCommand,
  clearStepTwoModel,
  setStepThreeModel,
  setStepFourModel,
  setStepFourCommand,
  setStepFiveModel,
  setStepFiveCommand,
  setStepSixModel,
  setStepSevenModel,
  setStepSixCommand,
  setStepSevenCommand,
  estelamAndSodoorWizardNextStep,
  estelamAndSodoorWizardPreviousStep,
  clearStepFiveModel,
  clearStepFourModel,
  clearStepOneModel,
  clearStepSixModel,
  clearStepSevenModel,
  setStepThreeCommand,
  clearStepThreeModel,
  resetWizard,
  setEstelamAndSodoorBimehNamehInitialState,
} = atashsooziEstelamAndSodoorReducer.actions;

export default atashsooziEstelamAndSodoorReducer.reducer;
